export enum ApplicationLangues {
    DEUTSCH = "Deutsch",
    ENGLISH = "English",
    ESPAÑOL = "Español",
    FRANÇAIS = "Français",
    汉法词典 = "汉法词典",
    РУССКИЙ = "Русский",
    TÜRKÇE = "Türkçe",
}